import GameState from "slotworks/model/game-state";
import GatewayResult from "model/gameplay/records/results/gateway-result";
import { LLWildSymbolResult } from "integration/builders/result/ll-wild-bonus-result-builder";

export function isGatewayResult() {
    const gameplay = GameState.getCurrentGame();
    const record = gameplay.getRootRecord();

    const hasGatewayResult = record.getResultsOfType(GatewayResult).length > 0;
    const gatewayResultUnplayed = record.getResultsOfType(GatewayResult).every((result) => !result.played);
    const gatewayResultWildSymbol = record.getResultsOfType(LLWildSymbolResult)[0];

    return hasGatewayResult && gatewayResultUnplayed || gatewayResultWildSymbol;
};